import script from "./LevelRebateForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./LevelRebateForm.vue?vue&type=script&setup=true&lang=ts"

import "./LevelRebateForm.vue?vue&type=style&index=0&id=b8636402&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8636402"]])

export default __exports__